<p-dialog
  [visible]="visible && showSurvey"
  (visibleChange)="$event ? (visible = true) : close()"
  [modal]="true"
  [closable]="false"
  [dismissableMask]="false"
  [draggable]="false"
  [resizable]="false"
  [showHeader]="false"
  styleClass="admin-style-survey-dialog"
>
  <div class="abi-nps-survey-wrap">
    <div class="abi-nps-survey-head">
      <h3>How likely are you to Promote AIPHO ?</h3>
      <button
        class="abi-nps-survey-close"
        type="button"
        aria-label="Close survey invitation"
        (click)="close()"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>

    <p class="abi-nps-survey-message">
      Your feedback helps us improve the AIPHO experience. Please complete this
      short survey.
    </p>

    <form
      class="abi-nps-survey-form"
      [formGroup]="surveyForm"
      (ngSubmit)="submit()"
    >
      <fieldset class="abi-nps-survey-fieldset">
        <legend>
          1. How likely are you to recommend AIPHO to others?
          <span class="required-indicator">*</span>
        </legend>
        <div class="abi-nps-rating-options">
          <label
            *ngFor="let rating of ratingScale"
            class="abi-nps-rating-option"
            [class.selected]="surveyForm.get('rating')?.value === rating"
            [class.detractor]="rating <= 6"
            [class.passive]="rating >= 7 && rating <= 8"
            [class.promoter]="rating >= 9"
            [attr.title]="ratingScaleAnchor(rating)"
            [attr.aria-label]="rating + ': ' + ratingScaleAnchor(rating)"
          >
            <input type="radio" formControlName="rating" [value]="rating" />
            <span>{{ rating }}</span>
          </label>
        </div>
        <div class="abi-nps-rating-endpoints" aria-hidden="true">
          <span>Not at all likely</span>
          <span>Extremely likely</span>
        </div>
        <small
          class="abi-nps-survey-error"
          *ngIf="
            surveyForm.get('rating')?.invalid &&
            surveyForm.get('rating')?.touched
          "
        >
          Please select a rating.
        </small>
      </fieldset>

      <div class="abi-nps-survey-influences">
        <div class="abi-nps-survey-question">
          2. What influenced your score?
          <span class="required-indicator">*</span>
        </div>
        <label *ngFor="let influence of scoreInfluences">
          <input
            type="checkbox"
            [checked]="
              surveyForm.get('influences')?.value?.includes(influence) ?? false
            "
            (change)="toggleInfluence(influence, $any($event.target).checked)"
          />
          <span>{{ influence }}</span>
        </label>
        <small
          class="abi-nps-survey-error"
          *ngIf="
            surveyForm.get('influences')?.invalid &&
            surveyForm.get('influences')?.touched
          "
        >
          Please select at least one influence.
        </small>
      </div>

      <div class="abi-nps-survey-text-field">
        <label for="abi-nps-worked-well"> 3. What worked well? </label>
        <textarea
          id="abi-nps-worked-well"
          formControlName="workedWell"
          rows="2"
          placeholder="Tell us as much as you like."
        ></textarea>
      </div>

      <div class="abi-nps-survey-text-field">
        <label for="abi-nps-can-improve"> 4. What could we improve? </label>
        <textarea
          id="abi-nps-can-improve"
          formControlName="canImprove"
          rows="2"
          placeholder="Tell us what we can improve."
        ></textarea>
      </div>

      <div class="abi-nps-survey-actions">
        <button
          class="abi-nps-survey-btn abi-nps-survey-btn-outline"
          type="button"
          (click)="close()"
        >
          Maybe Later
        </button>
        <button
          class="abi-nps-survey-btn abi-nps-survey-btn-dark"
          type="submit"
          [disabled]="isSubmitting"
        >
          {{ isSubmitting ? "Submitting..." : "Submit Feedback" }}
        </button>
      </div>
    </form>
  </div>
</p-dialog>
